
import { dayjs } from '#gp/app-common/util/dayjs';

export let simpleTimezones = [
    { id: "US/Samoa", name: "(GMT-11:00) American Samoa", },
    //{ id: "", name: "(GMT-11:00) International Date Line West", },
    { id: "Pacific/Midway", name: "(GMT-11:00) Midway Island", },
    { id: "US/Hawaii", name: "(GMT-10:00) Hawaii", },
    { id: "US/Alaska", name: "(GMT-09:00) Alaska", },
    { id: "Canada/Pacific", name: "(GMT-08:00) Pacific Time (US & Canada)", },
    { id: "America/Vancouver", name: "(GMT-08:00) Vancouver" },
    { id: "America/Tijuana", name: "(GMT-08:00) Tijuana", },
    { id: "US/Arizona", name: "(GMT-07:00) Arizona", },
    { id: "America/Chihuahua", name: "(GMT-07:00) Chihuahua", },
    { id: "America/Mazatlan", name: "(GMT-07:00) Mazatlan", },
    { id: "Canada/Mountain", name: "(GMT-07:00) Mountain Time (US & Canada)", },
    { id: "US/Central", name: "(GMT-06:00) Central America", },
    { id: "Canada/Central", name: "(GMT-06:00) Central Time (US & Canada)", },
    { id: "America/Monterrey", name: "(GMT-06:00) Monterrey", },
    { id: "America/Mexico_City", name: "(GMT-06:00) Mexico City", },
    { id: "Canada/Saskatchewan", name: "(GMT-06:00) Saskatchewan", },
    { id: "America/Bogota", name: "(GMT-05:00) Bogota", },
    { id: "America/Panama", name: "(GMT-05:00) Eastern Time (US & Canada)", },
    { id: "US/East-Indiana", name: "(GMT-05:00) Indiana (East)", },
    { id: "America/Lima", name: "(GMT-05:00) Lima", },
    { id: "America/Guayaquil", name: "(GMT-05:00) Quito", },
    { id: "America/Grenada", name: "(GMT-04:00) Atlantic Time (Canada)", },
    { id: "America/Caracas", name: "(GMT-04:00) Caracas", },
    { id: "America/Guyana", name: "(GMT-04:00) Georgetown", },
    { id: "America/La_Paz", name: "(GMT-04:00) La Paz", },
    { id: "America/Santiago", name: "(GMT-04:00) Santiago", },
    { id: "Canada/Newfoundland", name: "(GMT-03:30) Newfoundland", },
    { id: "America/Sao_Paulo", name: "(GMT-03:00) Brasilia", },
    { id: "America/Argentina/Buenos_Aires", name: "(GMT-03:00) Buenos Aires", },
    { id: "America/Godthab", name: "(GMT-03:00) Greenland", },
    { id: "America/Montevideo", name: "(GMT-03:00) Montevideo", },
    //{ id: "", name: "(GMT-02:00) Mid-Atlantic", },
    { id: "Atlantic/Azores", name: "(GMT-01:00) Azores", },
    { id: "Atlantic/Cape_Verde", name: "(GMT-01:00) Cape Verde Is.", },
    //{ id: "Europe/London.", name: "(GMT+00:00) Edinburgh", },
    { id: "Europe/Lisbon", name: "(GMT+00:00) Lisbon", },
    { id: "Europe/London", name: "(GMT+00:00) London", },
    { id: "Africa/Monrovia", name: "(GMT+00:00) Monrovia", },
    { id: "UTC", name: "(GMT+00:00) UTC", },
    { id: "Europe/Amsterdam", name: "(GMT+01:00) Amsterdam", },
    { id: "Europe/Belgrade", name: "(GMT+01:00) Belgrade", },
    { id: "Europe/Berlin", name: "(GMT+01:00) Berlin", },
    //{ id: "Europe/Zurich", name: "(GMT+01:00) Bern", },
    { id: "Europe/Bratislava", name: "(GMT+01:00) Bratislava", },
    { id: "Europe/Brussels", name: "(GMT+01:00) Brussels", },
    { id: "Europe/Budapest", name: "(GMT+01:00) Budapest", },
    { id: "Africa/Casablanca", name: "(GMT+01:00) Casablanca", },
    { id: "Europe/Copenhagen", name: "(GMT+01:00) Copenhagen", },
    { id: "Europe/Dublin", name: "(GMT+01:00) Dublin", },
    { id: "Europe/Berlin", name: "(GMT+01:00) Europe/Berlin", },
    { id: "Europe/Ljubljana", name: "(GMT+01:00) Ljubljana", },
    { id: "Europe/Madrid", name: "(GMT+01:00) Madrid", },
    { id: "Europe/Paris", name: "(GMT+01:00) Paris", },
    { id: "Europe/Prague", name: "(GMT+01:00) Prague", },
    { id: "Europe/Rome", name: "(GMT+01:00) Rome", },
    { id: "Europe/Sarajevo", name: "(GMT+01:00) Sarajevo", },
    { id: "Europe/Skopje", name: "(GMT+01:00) Skopje", },
    { id: "Europe/Stockholm", name: "(GMT+01:00) Stockholm", },
    { id: "Europe/Vienna", name: "(GMT+01:00) Vienna", },
    { id: "Europe/Warsaw", name: "(GMT+01:00) Warsaw", },
    { id: "Europe/Zagreb", name: "(GMT+01:00) Zagreb", },
    { id: "Europe/Zurich", name: "(GMT+01:00) Zurich", },
    { id: "Europe/Athens", name: "(GMT+02:00) Athens", },
    { id: "Europe/Bucharest", name: "(GMT+02:00) Bucharest", },
    { id: "Africa/Cairo", name: "(GMT+02:00) Cairo", },
    { id: "Africa/Harare", name: "(GMT+02:00) Harare", },
    { id: "Europe/Helsinki", name: "(GMT+02:00) Helsinki", },
    { id: "Asia/Jerusalem", name: "(GMT+02:00) Jerusalem", },
    { id: "Europe/Kaliningrad", name: "(GMT+02:00) Kaliningrad", },
    { id: "Europe/Kiev", name: "(GMT+02:00) Kyiv", },
    { id: "Africa/Johannesburg", name: "(GMT+02:00) Pretoria", },
    { id: "Europe/Riga", name: "(GMT+02:00) Riga", },
    { id: "Europe/Sofia", name: "(GMT+02:00) Sofia", },
    { id: "Europe/Tallinn", name: "(GMT+02:00) Tallinn", },
    { id: "Europe/Vilnius", name: "(GMT+02:00) Vilnius", },
    { id: "Asia/Baghdad", name: "(GMT+03:00) Baghdad", },
    { id: "Asia/Istanbul", name: "(GMT+03:00) Istanbul", },
    { id: "Asia/Kuwait", name: "(GMT+03:00) Kuwait", },
    { id: "Europe/Minsk", name: "(GMT+03:00) Minsk", },
    { id: "Europe/Moscow", name: "(GMT+03:00) Moscow", },
    { id: "Africa/Nairobi", name: "(GMT+03:00) Nairobi", },
    { id: "Asia/Riyadh", name: "(GMT+03:00) Riyadh", },
    { id: "Asia/Tehran", name: "(GMT+03:30) Tehran", },
    { id: "Asia/Dubai", name: "(GMT+04:00) Abu Dhabi", },
    { id: "Asia/Baku", name: "(GMT+04:00) Baku", },
    { id: "Asia/Muscat", name: "(GMT+04:00) Muscat", },
    { id: "Europe/Samara", name: "(GMT+04:00) Samara", },
    { id: "Asia/Tbilisi", name: "(GMT+04:00) Tbilisi", },
    { id: "Europe/Volgograd", name: "(GMT+04:00) Volgograd", },
    { id: "Asia/Yerevan", name: "(GMT+04:00) Yerevan", },
    { id: "Asia/Kabul", name: "(GMT+04:30) Kabul", },
    { id: "Asia/Yekaterinburg", name: "(GMT+05:00) Ekaterinburg", },
    { id: "Asia/Karachi", name: "(GMT+05:00) Karachi", },
    { id: "Asia/Tashkent", name: "(GMT+05:00) Tashkent", },
    { id: "Asia/Kolkata", name: "(GMT+05:30) Kolkata", },
    { id: "Asia/Kathmandu", name: "(GMT+05:45) Kathmandu", },
    { id: "Asia/Almaty", name: "(GMT+06:00) Almaty", },
    { id: "Asia/Dhaka", name: "(GMT+06:00) Dhaka", },
    { id: "Asia/Urumqi", name: "(GMT+06:00) Urumqi", },
    { id: "Asia/Rangoon", name: "(GMT+06:30) Rangoon", },
    { id: "Asia/Bangkok", name: "(GMT+07:00) Bangkok", },
    //{ id: "", name: "(GMT+07:00) Hanoi", },
    { id: "Asia/Jakarta", name: "(GMT+07:00) Jakarta", },
    { id: "Asia/Krasnoyarsk", name: "(GMT+07:00) Krasnoyarsk", },
    { id: "Asia/Novosibirsk", name: "(GMT+07:00) Novosibirsk", },
    { id: "Asia/Shanghai", name: "(GMT+08:00) Beijing", },
    { id: "Asia/Chongqing", name: "(GMT+08:00) Chongqing", },
    { id: "Asia/Hong_Kong", name: "(GMT+08:00) Hong Kong", },
    { id: "Asia/Irkutsk", name: "(GMT+08:00) Irkutsk", },
    { id: "Asia/Kuala_Lumpur", name: "(GMT+08:00) Kuala Lumpur", },
    { id: "Australia/Perth", name: "(GMT+08:00) Perth", },
    { id: "Asia/Singapore", name: "(GMT+08:00) Singapore", },
    { id: "Asia/Taipei", name: "(GMT+08:00) Taipei", },
    { id: "Asia/Ulaanbaatar", name: "(GMT+08:00) Ulaanbaatar", },
    { id: "Asia/Seoul", name: "(GMT+09:00) Seoul", },
    { id: "Asia/Tokyo", name: "(GMT+09:00) Tokyo", },
    { id: "Asia/Yakutsk", name: "(GMT+09:00) Yakutsk", },
    { id: "Australia/Adelaide", name: "(GMT+09:30) Adelaide", },
    { id: "Australia/Darwin", name: "(GMT+09:30) Darwin", },
    { id: "Australia/Brisbane", name: "(GMT+10:00) Brisbane", },
    { id: "Australia/Canberra", name: "(GMT+10:00) Canberra", },
    { id: "Pacific/Guam", name: "(GMT+10:00) Guam", },
    { id: "Australia/Hobart", name: "(GMT+10:00) Hobart", },
    { id: "Australia/Melbourne", name: "(GMT+10:00) Melbourne", },
    { id: "Pacific/Port_Moresby", name: "(GMT+10:00) Port Moresby", },
    { id: "Australia/Sydney", name: "(GMT+10:00) Sydney", },
    { id: "Asia/Vladivostok", name: "(GMT+10:00) Vladivostok", },
    { id: "Asia/Magadan", name: "(GMT+11:00) Magadan", },
    { id: "Pacific/Noumea", name: "(GMT+11:00) New Caledonia", },
    { id: "Pacific/Guadalcanal", name: "(GMT+11:00) Solomon Is.", },
    { id: "Pacific/Auckland", name: "(GMT+12:00) Auckland", },
    { id: "Pacific/Fiji", name: "(GMT+12:00) Fiji", },
    { id: "Asia/Kamchatka", name: "(GMT+12:00) Kamchatka", },
    { id: "Pacific/Kwajalein", name: "(GMT+12:00) Marshall Is.", },
    { id: "Pacific/Chatham", name: "(GMT+12:45) Chatham Is.", },
    { id: "Pacific/Tongatapu", name: "(GMT+13:00) Nuku'alofa", },
    { id: "Pacific/Samoa", name: "(GMT+13:00) Samoa", },
    { id: "Pacific/Fakaofo", name: "(GMT+13:00) Tokelau Is.", },
];

export function guessSimpleTimezone(): string {
    let guessTz = dayjs.tz.guess()

    if (!guessTz) return guessTz;

    // if our guessed moment is already in our simple list, lets just use it.
    let simpleGuessed = simpleTimezones.filter(simple => simple.id === guessTz);

    if (simpleGuessed.length > 0) return guessTz;


    // if we haven't then lets pick the closest 
    let utcNow = dayjs.utc();
    let guessOffset = dayjs.tz(utcNow, guessTz).utcOffset();

    let bestDiff = 10000;
    let bestTimezone: string | null = null;

    simpleTimezones.forEach(simple => {
        let simpleOffset = dayjs.tz(utcNow, simple.id).utcOffset()

        let simpleDiff = simpleOffset - guessOffset;


        if (Math.abs(simpleDiff) < Math.abs(bestDiff)) {
            bestDiff = simpleDiff;
            bestTimezone = simple.id;
        }
    });

    return bestTimezone || guessTz;
}
